import React, { Component } from "react";
import _ from "lodash";
import "./style.css";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ONR_CwrMaintenanceRecordFormSectionsSchema } from "./ONR_CwrMaintenanceRecordFormSchema";
import { onrCwrMaintenanceFormInstructions } from "./instructionList";

const { instructionsTable, instructionsTableHeader } = ONR_CwrMaintenanceRecordFormSectionsSchema;

const ONR_CwrMaintenanceRecordFormInstructions = () => {
  return (
    <React.Fragment>
      <div className="avoid-break-in-printing onr_cwr-maintenance-record-form">
        <ReportTitleSection title="CWR Maintenance Record Form Instructions" hideLogo={true} />
        <table className="table-bordered" style={{ width: "100%", marginBottom: "0px" }}>
          <ReportTableSectionRenderer section={instructionsTableHeader} />
          <tbody>
            <tr>
              <td colSpan={10}>
                <div style={{ textAlign: "left", padding: "5px 5px 0" }}>
                  {onrCwrMaintenanceFormInstructions.freeTextList.map((freeText) => {
                    if (freeText.type === "list") {
                      return (
                        <ol>
                          {freeText.content.map((item) => (
                            <li>{item}</li>
                          ))}
                        </ol>
                      );
                    } else if (freeText.type === "text") {
                      return <div>{freeText.content}</div>;
                    } else return null;
                  })}
                </div>
              </td>
            </tr>
          </tbody>
          <ReportTableSectionRenderer section={instructionsTable} rowsData={[onrCwrMaintenanceFormInstructions.tableData]} />
        </table>
      </div>
    </React.Fragment>
  );
};
export default ONR_CwrMaintenanceRecordFormInstructions;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/CwrMaintenanceRecordForm/instructions.jsx